module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.plansList,
      "label": "Select an existing plan"
    },
    model: {
      value: (_vm.itemData.plans_id),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "plans_id", $$v)
      },
      expression: "itemData.plans_id"
    }
  }), _vm._v(" "), (_vm.selectedPlan > 0) ? _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.servicesList,
      "multiple": "",
      "label": "Select services (replaces already added)"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")]
      }
    }], null, false, 2095008220),
    model: {
      value: (_vm.itemData.services),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "services", $$v)
      },
      expression: "itemData.services"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isInDialog && _vm.casesId > 0) ? _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Comfort S30', 'Comfort S803', 'Deluxe Lotus S809', 'S220', 'Teak'],
      "label": "Select Casket Model"
    },
    model: {
      value: (_vm.itemData.casket_model),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "casket_model", $$v)
      },
      expression: "itemData.casket_model"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.itemData.services && _vm.itemData.services.length > 0 && this.enableChecklist) ? _c('v-flex', {
    staticClass: "text-md-left"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.selectedServicesList,
      "label": "Select service to edit checklist"
    },
    model: {
      value: (_vm.selectedServiceForChecklist),
      callback: function($$v) {
        _vm.selectedServiceForChecklist = $$v
      },
      expression: "selectedServiceForChecklist"
    }
  }), _vm._v(" "), (_vm.selectedServiceForChecklist > 0) ? _c('ItemCheckList', {
    attrs: {
      "cases-id": _vm.itemData.id,
      "item-id": _vm.selectedServiceForChecklist,
      "item-type": _vm.serviceTypeID
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemData(_vm.finalItemId)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.isInDialog) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$bus.$emit('dialog-close')
      }
    }
  }, [_vm._v("Close")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90961b92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CasePlanAndServicesEdition.vue
// module id = 994
// module chunks = 1